"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: {
        type: Boolean,
        default: undefined
    },
    dataSource: {
        type: [Object, Array],
        default: undefined
    },
    editTemplate: {
        type: [String, Function],
        default: undefined
    },
    navigatable: {
        type: Boolean,
        default: undefined
    },
    selectable: {
        type: [Boolean, String],
        default: undefined
    },
    template: {
        type: [String, Function],
        default: undefined
    },
    altTemplate: {
        type: [String, Function],
        default: undefined
    },
    height: {
        type: [Number, String],
        default: undefined
    },
    scrollable: {
        type: [Boolean, String],
        default: undefined
    },

    // Events
    cancel: Function,
    change: Function,
    dataBound: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    edit: Function,
    remove: Function,
    save: Function
};